import { MenuItemOption } from "@components/common/mobile/mobile-types";
import { SdbMemberTypes } from "@custom-types/member-types";
import { SdbProject } from "@custom-types/project-types";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { toggleItemSelection } from "@utils/array-utils";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { InfoIcon, SelectionIcon } from "@flat-ui";
import { useMembersUtils } from "@hooks/use-member-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useProjectRemoveMenuOption } from "@hooks/use-project-remove-menu-option";

interface UseProjectTeamMenuOptionsMobileParams {
  /** The selected project */
  selectedProject?: SdbProject | null;
}

/** Hook to get the menu options for the project team members in the mobile view */
export function useProjectTeamMenuOptionsMobile({
  selectedProject,
}: UseProjectTeamMenuOptionsMobileParams): MenuItemOption<SdbMemberTypes>[] {
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const { openProfilePage } = useMembersUtils();

  const selectedRowIds = useAppSelector(selectedRowIdsSelector);

  const { projectRemoveMenuOption, shouldShowProjectRemove } =
    useProjectRemoveMenuOption({
      companyId,
      selectedProject,
    });

  return [
    {
      label: "Select member",
      Icon: SelectionIcon,
      onSelect: (member) => {
        const newSelectedRowIds = toggleItemSelection(
          selectedRowIds,
          member.identity
        );
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      },
      shouldShowDividerAfter: true,
    },
    {
      label: "Profile",
      Icon: InfoIcon,
      onSelect: (member) => {
        openProfilePage({
          member,
          source: "user more info menu mobile",
        });
      },
      shouldShowDividerAfter: shouldShowProjectRemove,
    },
    ...projectRemoveMenuOption,
  ];
}
